import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpContextToken,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import {
	catchError,
	delay,
	Observable,
	switchMap,
	throwError,
} from 'rxjs';

import { AuthService } from '../services/auth.service';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor {
	constructor(
		private readonly authService: AuthService,
		private readonly location: Location,
	) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// Skip auth if context token is set or if no token is available
		if (request.context.get(SKIP_AUTH) || !this.authService.jwtToken) {
			return next.handle(request).pipe(
				catchError((error) => {
					// Don't attempt token refresh for unauthenticated requests
					return throwError(() => error);
				})
			);
		}

		return next
			.handle(request.clone({
				headers: request.headers.append(
					'Authorization',
					`Bearer ${this.authService.jwtToken}`
				),
			}))
			.pipe(
				catchError((error) => {
					if (error.status === 401 && this.authService.cognitoUserState.getValue() !== 'loading') {
						return this.authService.reloadCognitoUser(true)
							.pipe(
								catchError(refreshError => {
									// Token refresh failed — session is invalid, force re-login
									this.authService.logout(this.location.path(), 'session-expired');
									return throwError(() => refreshError);
								}),
								delay(100),
								switchMap(() => next.handle(request.clone({
									headers: request.headers.append(
										'Authorization',
										`Bearer ${this.authService.jwtToken}`
									),
								})))
							);
					}

					return throwError(() => error);
				})
			);
	}
}